import QRCodeVue from '@/views/sm/qr-code/qr-code.vue';

const basePath = '/sm/qr-code';
const role = 'sm'; // 角色身份

export const SM_QR_CODE_INDEX = 'sm-qr-code';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: QRCodeVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SM_QR_CODE_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/qr-code/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
